const parseDate = (string) => Math.floor(Date.parse(string));

export default parseDate;
